import QuizIcon from "@mui/icons-material/Quiz";
import CompassNameIcon from "../images/general/CgiNameIconBlack.svg";
import CompassLogoGradient from "../images/general/CompassIconGradient.svg";
import SpecialText from "./SpecialText";
import { t } from "i18next";
import { Box, Button, Icon, Typography } from "@mui/material";
import { CGI_GRADIENT_A_45DEG } from "../helpers/enums";

export default function ThankYouScreen() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontSize: 37,
          fontWeight: 500,
          mt: 3,
        }}
      >
        <SpecialText
          style={{
            background: CGI_GRADIENT_A_45DEG,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {t("thankYou")}
        </SpecialText>{" "}
        {t("forYourInterest")}
      </Typography>
      <Typography sx={{ fontFamily: "Inter", fontSize: 18, mt: 10 }}>
        {t("furtherInformationViaMail")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          mt: 15,
        }}
      >
        <Icon sx={{ width: "auto", height: "auto" }}>
          <img draggable={false} src={CompassLogoGradient} height={"55px"} />
        </Icon>
        <Icon sx={{ width: "auto", height: "auto", ml: 2 }}>
          <img draggable={false} src={CompassNameIcon} height="50px" />
        </Icon>
      </Box>
      <Button
        variant="outlined"
        sx={{ borderRadius: 20, mt: 15 }}
        endIcon={<QuizIcon />}
        onClick={() => {
          localStorage.clear();
          window.location.reload();
        }}
      >
        {t("startNewAssessment")}
      </Button>
    </Box>
  );
}
